import { render, staticRenderFns } from "./start-modal.component.vue?vue&type=template&id=dd2a6faa&scoped=true"
import script from "./start-modal.component.vue?vue&type=script&lang=js"
export * from "./start-modal.component.vue?vue&type=script&lang=js"
import style0 from "./start-modal.component.vue?vue&type=style&index=0&id=dd2a6faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2a6faa",
  null
  
)

export default component.exports